module.exports = __webpack_public_path__ + "static/media/galeria_elo_11.613c364f.jpg";